module.exports = {"id":"216433","name":"Anwar El Ghazi","rating":"73","photo":"./data/images/photos/3/216433.png","club":{"name":"LOSC","logo":"./data/images/clubs/LOSC.png"},"positions":["AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AnwarElGhazi0.json
// module id = 453
// module chunks = 0